// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";

// const firebaseConfig = {
//     apiKey: "AIzaSyApzbanRgYuv3n-ohAemddr5Qppr5yQ020",
//     authDomain: "hotel-aef2b.firebaseapp.com",
//     projectId: "hotel-aef2b",
//     storageBucket: "hotel-aef2b.appspot.com",
//     messagingSenderId: "871753425702",
//     appId: "1:871753425702:web:0b71c24a2095697f2957e7",
//     measurementId: "G-34HSWJBG1J"
// };
const firebaseConfig = {
    apiKey: "AIzaSyALbCBYFmHha3XponR5wGDFGeiRlnpvN9A",
    authDomain: "hotel-212b7.firebaseapp.com",
    projectId: "hotel-212b7",
    storageBucket: "hotel-212b7.appspot.com",
    messagingSenderId: "760909154486",
    appId: "1:760909154486:web:62cccbcd2297bbec69be17",
    measurementId: "G-6N0R7FY4J0"
  };

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);

export default firebaseApp